import { Component, Input } from '@angular/core';
import { Helper } from 'src/app/_classes';
import { ChildFeedItem, DataObjects, SocialPost } from 'src/app/_interfaces';
import { AppStringsService, LinkifyService } from 'src/app/_services';
import { SplideConfig } from '../carousel/splide-config';
import { DatePipe } from '@angular/common';
import { CarouselComponent } from '../carousel/carousel.component';
import { SlideComponent } from '../carousel/slide/slide.component';
import { ImageComponent } from '../image/image.component';

@Component({
    selector: 'app-social-feed-carousel',
    templateUrl: './social-feed-carousel.component.html',
    styleUrls: ['./social-feed-carousel.component.scss'],
    imports: [CarouselComponent, SlideComponent, ImageComponent, DatePipe]
})
export class SocialFeedCarouselComponent {
    @Input() social_feed: DataObjects = {} as DataObjects;
    @Input() should_show_header: boolean = false;

    public feedName: string = ''
    public feedLogo: string = ''

    private helper = new Helper()

    constructor(
        private linkify: LinkifyService,
        public appStringAPI: AppStringsService
    ) { }

    // ngOnInit(): void {
    //     if (this.social_feed) {
    //         console.log(this.social_feed)
    //     }
    // }

    isYoutubeVideo(item: SocialPost): boolean {
        return item?.feed_type?.toLowerCase?.() === 'youtube';
    }

    profileImage(item: SocialPost | ChildFeedItem): string {
        return item && item.hasOwnProperty('user_image') ? this.helper.ensureHTTPS(item.user_image) : this.helper.ensureHTTPS(this.social_feed.profile_icon)
    }

    get feedItems(): SocialPost[] {
        return this.social_feed && this.social_feed.hasOwnProperty('items') ? this.social_feed.items as SocialPost[] : []
    }

    get feedType(): string {
        return this.social_feed && this.social_feed.hasOwnProperty('feed_type') ? this.social_feed.feed_type as string : ''
    }

    isImage(item: SocialPost) {
        return this.helper.isImageURL(item.media_content);
    }

    handleBackground(image_url: string): string {
        return this.helper.handleBackgroundURL(image_url);
    }

    openLink(url: string) {
        window.open(url);
    }

    parseDesc(desc: string, feed_type: string) {
        return this.linkify.parse(desc, feed_type);
    }

    hasChild(item: SocialPost): boolean {
        if (!item || !item.child_feed_item) {
            return false
        }

        return Object.keys(item.child_feed_item).length > 0 ? true : false
    }

    get splideConfig() {
        return new SplideConfig().options({
            type: 'slide',
            perPage: 1.2,
            gap: '1.2rem',
            padding: '0rem',
            focus: 'center',
            trimSpace: true,
            drag: true,
            fixedHeight: '250px',
            autoWidth: true,
            arrows: true
        })
    }
}
